<footer class="footer">
    <div class="container">
        <div class="copyright pull-right">
            <a href="https://www.sigaonline.com.br">
        SIGA Online
      </a> &copy; {{test | date: 'yyyy'}},
            <a href="https://www.mvminformatica.com.br" class="ml-auto" target="_blank">MVMInfo Informática</a>
        </div>
    </div>
</footer>